export default {
  metrics: {
    nrr: {
      title: 'NRR % (Kwartaal)',
      description:
        '(Abonnementsomzet {{currentMonth}} (Q{{currentQuarter}}) + Servicefee-omzet {{currentMonth}} (Q{{currentQuarter}})) / (Abonnementsomzet {{prevMonth}} (einde Q{{prevQuarter}}) + Servicefee-omzet {{prevMonth}} (einde Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Account-upgrades',
    downgrades: 'Account-downgrades',
    gte_c_tier: 'Accounts ≥ Klasse C',
    churn: 'Verloop (opgeschort)',
    offers_turned_on: 'Aanbiedingen ingeschakeld',
    flyers_sent: 'Flyers verzonden',
    on_google_ads_trial: 'Op Google Ads-proefperiode',
    converted_google_ads: 'Google Ads succesvol geconverteerd',
    first_time_500_monthly_sales: 'Eerste €500-maand',
    '14_days_no_sales': '14 dagen live, geen omzet',
  },
  details: {
    address: 'Adres',
    subscriptions: 'Huidige abonnementen',
    best_sales: 'Beste maand ooit',
    sales: '{{month}} omzet',
    tier: '{{month}} niveau',
    live_from: 'Go-live datum',
    owner_phone: 'Telefoonnummer eigenaar',
    owner_email: 'E-mail eigenaar',
    owner: 'Naam eigenaar',
    name: 'Restaurant',
    export_csv: 'CSV exporteren',
  },
  publish: 'Publiceren',
  unpublish: 'Depubliceren',
};
